import { render } from "./TablaComparacionSait.vue?vue&type=template&id=71c2ad0e&scoped=true"
import script from "./TablaComparacionSait.vue?vue&type=script&lang=js"
export * from "./TablaComparacionSait.vue?vue&type=script&lang=js"

import "./TablaComparacionSait.vue?vue&type=style&index=0&id=71c2ad0e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71c2ad0e"

export default script